/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InvitationsRouteImport } from './routes/invitations'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminCampaignsRouteImport } from './routes/admin.campaigns'
import { Route as AdminDesktopGpusRouteImport } from './routes/admin.desktop-gpus'
import { Route as AdminFrictionRouteImport } from './routes/admin.friction'
import { Route as AdminFunnelRouteImport } from './routes/admin.funnel'
import { Route as AdminHealthRouteImport } from './routes/admin.health'
import { Route as AdminPoolsRouteImport } from './routes/admin.pools'
import { Route as AdminProblemsRouteImport } from './routes/admin.problems'
import { Route as AdminQueuesRouteImport } from './routes/admin.queues'
import { Route as AdminRetentionRouteImport } from './routes/admin.retention'
import { Route as AdminRevenueRouteImport } from './routes/admin.revenue'
import { Route as AdminTimelineRouteImport } from './routes/admin.timeline'
import { Route as AdminTodayRouteImport } from './routes/admin.today'
import { Route as AdminUsageRouteImport } from './routes/admin.usage'
import { Route as DevelopersIndexRouteImport } from './routes/developers.index'
import { Route as DevelopersGuideRouteImport } from './routes/developers.$guide'
import { Route as DevelopersReferenceRouteImport } from './routes/developers.reference'
import { Route as DeviceConnectRouteImport } from './routes/device_.connect'
import { Route as DeviceConnectedRouteImport } from './routes/device_.connected'
import { Route as EmailUnsubscribeRouteImport } from './routes/email.unsubscribe'
import { Route as MAdminRouteImport } from './routes/m.admin'
import { Route as MInviteRouteImport } from './routes/m.invite'
import { Route as SignInConceptRouteImport } from './routes/sign-in_.concept'
import { Route as SignInPlainRouteImport } from './routes/sign-in_.plain'
import { Route as TTenantRouteImport } from './routes/t.$tenant'
import { Route as AdminCustomersTenantRouteImport } from './routes/admin.customers.$tenant'
import { Route as AdminPartnersIndexRouteImport } from './routes/admin.partners.index'
import { Route as AdminPartnersAccountRouteImport } from './routes/admin.partners.$account'
import { Route as TTenantIndexRouteImport } from './routes/t.$tenant.index'
import { Route as TTenantPackageRouteImport } from './routes/t.$tenant.package'
import { Route as TTenantSettingsRouteImport } from './routes/t.$tenant.settings'
import { Route as TTenantJobsNewRouteImport } from './routes/t.$tenant.jobs.new'
import { Route as TTenantSettingsIndexRouteImport } from './routes/t.$tenant.settings.index'
import { Route as TTenantSettingsPeopleRouteImport } from './routes/t.$tenant.settings.people'
import { Route as TTenantJobsJobReviewRouteImport } from './routes/t.$tenant.jobs.$job.review'
import { Route as TTenantSettingsBillingIndexRouteImport } from './routes/t.$tenant.settings.billing.index'
import { Route as TTenantSettingsBillingAlertsRouteImport } from './routes/t.$tenant.settings.billing.alerts'
import { Route as TTenantSettingsBillingPartnerRouteImport } from './routes/t.$tenant.settings.billing.partner'
import { Route as TTenantSettingsBillingPlanRouteImport } from './routes/t.$tenant.settings.billing.plan'
import { Route as TTenantSettingsBillingUsageRouteImport } from './routes/t.$tenant.settings.billing.usage'
import { Route as TTenantSettingsCompanyIndexRouteImport } from './routes/t.$tenant.settings.company.index'
import { Route as TTenantSettingsCompanyActivityRouteImport } from './routes/t.$tenant.settings.company.activity'
import { Route as TTenantSettingsCompanyDevicesRouteImport } from './routes/t.$tenant.settings.company.devices'
import { Route as TTenantSettingsCompanyDocumentsRouteImport } from './routes/t.$tenant.settings.company.documents'
import { Route as TTenantSettingsCompanyGeneralRouteImport } from './routes/t.$tenant.settings.company.general'
import { Route as TTenantSettingsCompanyPeopleRouteImport } from './routes/t.$tenant.settings.company.people'
import { Route as TTenantSettingsCompanyScanRouteImport } from './routes/t.$tenant.settings.company.scan'
import { Route as TTenantSettingsCompanySecurityRouteImport } from './routes/t.$tenant.settings.company.security'
import { Route as TTenantSettingsDevelopersIndexRouteImport } from './routes/t.$tenant.settings.developers.index'
import { Route as TTenantSettingsDevelopersKeysRouteImport } from './routes/t.$tenant.settings.developers.keys'
import { Route as TTenantSettingsDevelopersScanRouteImport } from './routes/t.$tenant.settings.developers.scan'
import { Route as TTenantSettingsDevelopersSendRouteImport } from './routes/t.$tenant.settings.developers.send'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersRoute = DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsRoute = InvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCampaignsRoute = AdminCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDesktopGpusRoute = AdminDesktopGpusRouteImport.update({
  id: '/desktop-gpus',
  path: '/desktop-gpus',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFrictionRoute = AdminFrictionRouteImport.update({
  id: '/friction',
  path: '/friction',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFunnelRoute = AdminFunnelRouteImport.update({
  id: '/funnel',
  path: '/funnel',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPoolsRoute = AdminPoolsRouteImport.update({
  id: '/pools',
  path: '/pools',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProblemsRoute = AdminProblemsRouteImport.update({
  id: '/problems',
  path: '/problems',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQueuesRoute = AdminQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRetentionRoute = AdminRetentionRouteImport.update({
  id: '/retention',
  path: '/retention',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRevenueRoute = AdminRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTimelineRoute = AdminTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTodayRoute = AdminTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AdminRoute,
} as any)
const DevelopersIndexRoute = DevelopersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevelopersRoute,
} as any)
const DevelopersGuideRoute = DevelopersGuideRouteImport.update({
  id: '/$guide',
  path: '/$guide',
  getParentRoute: () => DevelopersRoute,
} as any)
const DevelopersReferenceRoute = DevelopersReferenceRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => DevelopersRoute,
} as any)
const DeviceConnectRoute = DeviceConnectRouteImport.update({
  id: '/device_/connect',
  path: '/device/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceConnectedRoute = DeviceConnectedRouteImport.update({
  id: '/device_/connected',
  path: '/device/connected',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailUnsubscribeRoute = EmailUnsubscribeRouteImport.update({
  id: '/email/unsubscribe',
  path: '/email/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const MAdminRoute = MAdminRouteImport.update({
  id: '/m/admin',
  path: '/m/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const MInviteRoute = MInviteRouteImport.update({
  id: '/m/invite',
  path: '/m/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInConceptRoute = SignInConceptRouteImport.update({
  id: '/sign-in_/concept',
  path: '/sign-in/concept',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInPlainRoute = SignInPlainRouteImport.update({
  id: '/sign-in_/plain',
  path: '/sign-in/plain',
  getParentRoute: () => rootRouteImport,
} as any)
const TTenantRoute = TTenantRouteImport.update({
  id: '/t/$tenant',
  path: '/t/$tenant',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCustomersTenantRoute = AdminCustomersTenantRouteImport.update({
  id: '/customers/$tenant',
  path: '/customers/$tenant',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPartnersIndexRoute = AdminPartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPartnersAccountRoute = AdminPartnersAccountRouteImport.update({
  id: '/partners/$account',
  path: '/partners/$account',
  getParentRoute: () => AdminRoute,
} as any)
const TTenantIndexRoute = TTenantIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TTenantRoute,
} as any)
const TTenantPackageRoute = TTenantPackageRouteImport.update({
  id: '/package',
  path: '/package',
  getParentRoute: () => TTenantRoute,
} as any)
const TTenantSettingsRoute = TTenantSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => TTenantRoute,
} as any)
const TTenantJobsNewRoute = TTenantJobsNewRouteImport.update({
  id: '/jobs/new',
  path: '/jobs/new',
  getParentRoute: () => TTenantRoute,
} as any)
const TTenantSettingsIndexRoute = TTenantSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TTenantSettingsRoute,
} as any)
const TTenantSettingsPeopleRoute = TTenantSettingsPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => TTenantSettingsRoute,
} as any)
const TTenantJobsJobReviewRoute = TTenantJobsJobReviewRouteImport.update({
  id: '/jobs/$job/review',
  path: '/jobs/$job/review',
  getParentRoute: () => TTenantRoute,
} as any)
const TTenantSettingsBillingIndexRoute =
  TTenantSettingsBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsBillingAlertsRoute =
  TTenantSettingsBillingAlertsRouteImport.update({
    id: '/billing/alerts',
    path: '/billing/alerts',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsBillingPartnerRoute =
  TTenantSettingsBillingPartnerRouteImport.update({
    id: '/billing/partner',
    path: '/billing/partner',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsBillingPlanRoute =
  TTenantSettingsBillingPlanRouteImport.update({
    id: '/billing/plan',
    path: '/billing/plan',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsBillingUsageRoute =
  TTenantSettingsBillingUsageRouteImport.update({
    id: '/billing/usage',
    path: '/billing/usage',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanyIndexRoute =
  TTenantSettingsCompanyIndexRouteImport.update({
    id: '/company/',
    path: '/company/',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanyActivityRoute =
  TTenantSettingsCompanyActivityRouteImport.update({
    id: '/company/activity',
    path: '/company/activity',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanyDevicesRoute =
  TTenantSettingsCompanyDevicesRouteImport.update({
    id: '/company/devices',
    path: '/company/devices',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanyDocumentsRoute =
  TTenantSettingsCompanyDocumentsRouteImport.update({
    id: '/company/documents',
    path: '/company/documents',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanyGeneralRoute =
  TTenantSettingsCompanyGeneralRouteImport.update({
    id: '/company/general',
    path: '/company/general',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanyPeopleRoute =
  TTenantSettingsCompanyPeopleRouteImport.update({
    id: '/company/people',
    path: '/company/people',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanyScanRoute =
  TTenantSettingsCompanyScanRouteImport.update({
    id: '/company/scan',
    path: '/company/scan',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsCompanySecurityRoute =
  TTenantSettingsCompanySecurityRouteImport.update({
    id: '/company/security',
    path: '/company/security',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsDevelopersIndexRoute =
  TTenantSettingsDevelopersIndexRouteImport.update({
    id: '/developers/',
    path: '/developers/',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsDevelopersKeysRoute =
  TTenantSettingsDevelopersKeysRouteImport.update({
    id: '/developers/keys',
    path: '/developers/keys',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsDevelopersScanRoute =
  TTenantSettingsDevelopersScanRouteImport.update({
    id: '/developers/scan',
    path: '/developers/scan',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)
const TTenantSettingsDevelopersSendRoute =
  TTenantSettingsDevelopersSendRouteImport.update({
    id: '/developers/send',
    path: '/developers/send',
    getParentRoute: () => TTenantSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/developers': typeof DevelopersRouteWithChildren
  '/device': typeof DeviceRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invitations': typeof InvitationsRoute
  '/pricing': typeof PricingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/campaigns': typeof AdminCampaignsRoute
  '/admin/desktop-gpus': typeof AdminDesktopGpusRoute
  '/admin/friction': typeof AdminFrictionRoute
  '/admin/funnel': typeof AdminFunnelRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/pools': typeof AdminPoolsRoute
  '/admin/problems': typeof AdminProblemsRoute
  '/admin/queues': typeof AdminQueuesRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/revenue': typeof AdminRevenueRoute
  '/admin/timeline': typeof AdminTimelineRoute
  '/admin/today': typeof AdminTodayRoute
  '/admin/usage': typeof AdminUsageRoute
  '/developers/$guide': typeof DevelopersGuideRoute
  '/developers/reference': typeof DevelopersReferenceRoute
  '/device/connect': typeof DeviceConnectRoute
  '/device/connected': typeof DeviceConnectedRoute
  '/email/unsubscribe': typeof EmailUnsubscribeRoute
  '/m/admin': typeof MAdminRoute
  '/m/invite': typeof MInviteRoute
  '/sign-in/concept': typeof SignInConceptRoute
  '/sign-in/plain': typeof SignInPlainRoute
  '/t/$tenant': typeof TTenantRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/developers/': typeof DevelopersIndexRoute
  '/admin/customers/$tenant': typeof AdminCustomersTenantRoute
  '/admin/partners/$account': typeof AdminPartnersAccountRoute
  '/t/$tenant/package': typeof TTenantPackageRoute
  '/t/$tenant/settings': typeof TTenantSettingsRouteWithChildren
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/t/$tenant/': typeof TTenantIndexRoute
  '/t/$tenant/jobs/new': typeof TTenantJobsNewRoute
  '/t/$tenant/settings/people': typeof TTenantSettingsPeopleRoute
  '/t/$tenant/settings/': typeof TTenantSettingsIndexRoute
  '/t/$tenant/jobs/$job/review': typeof TTenantJobsJobReviewRoute
  '/t/$tenant/settings/billing/alerts': typeof TTenantSettingsBillingAlertsRoute
  '/t/$tenant/settings/billing/partner': typeof TTenantSettingsBillingPartnerRoute
  '/t/$tenant/settings/billing/plan': typeof TTenantSettingsBillingPlanRoute
  '/t/$tenant/settings/billing/usage': typeof TTenantSettingsBillingUsageRoute
  '/t/$tenant/settings/company/activity': typeof TTenantSettingsCompanyActivityRoute
  '/t/$tenant/settings/company/devices': typeof TTenantSettingsCompanyDevicesRoute
  '/t/$tenant/settings/company/documents': typeof TTenantSettingsCompanyDocumentsRoute
  '/t/$tenant/settings/company/general': typeof TTenantSettingsCompanyGeneralRoute
  '/t/$tenant/settings/company/people': typeof TTenantSettingsCompanyPeopleRoute
  '/t/$tenant/settings/company/scan': typeof TTenantSettingsCompanyScanRoute
  '/t/$tenant/settings/company/security': typeof TTenantSettingsCompanySecurityRoute
  '/t/$tenant/settings/developers/keys': typeof TTenantSettingsDevelopersKeysRoute
  '/t/$tenant/settings/developers/scan': typeof TTenantSettingsDevelopersScanRoute
  '/t/$tenant/settings/developers/send': typeof TTenantSettingsDevelopersSendRoute
  '/t/$tenant/settings/billing/': typeof TTenantSettingsBillingIndexRoute
  '/t/$tenant/settings/company/': typeof TTenantSettingsCompanyIndexRoute
  '/t/$tenant/settings/developers/': typeof TTenantSettingsDevelopersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/device': typeof DeviceRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invitations': typeof InvitationsRoute
  '/pricing': typeof PricingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/campaigns': typeof AdminCampaignsRoute
  '/admin/desktop-gpus': typeof AdminDesktopGpusRoute
  '/admin/friction': typeof AdminFrictionRoute
  '/admin/funnel': typeof AdminFunnelRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/pools': typeof AdminPoolsRoute
  '/admin/problems': typeof AdminProblemsRoute
  '/admin/queues': typeof AdminQueuesRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/revenue': typeof AdminRevenueRoute
  '/admin/timeline': typeof AdminTimelineRoute
  '/admin/today': typeof AdminTodayRoute
  '/admin/usage': typeof AdminUsageRoute
  '/developers/$guide': typeof DevelopersGuideRoute
  '/developers/reference': typeof DevelopersReferenceRoute
  '/device/connect': typeof DeviceConnectRoute
  '/device/connected': typeof DeviceConnectedRoute
  '/email/unsubscribe': typeof EmailUnsubscribeRoute
  '/m/admin': typeof MAdminRoute
  '/m/invite': typeof MInviteRoute
  '/sign-in/concept': typeof SignInConceptRoute
  '/sign-in/plain': typeof SignInPlainRoute
  '/admin': typeof AdminIndexRoute
  '/developers': typeof DevelopersIndexRoute
  '/admin/customers/$tenant': typeof AdminCustomersTenantRoute
  '/admin/partners/$account': typeof AdminPartnersAccountRoute
  '/t/$tenant/package': typeof TTenantPackageRoute
  '/admin/partners': typeof AdminPartnersIndexRoute
  '/t/$tenant': typeof TTenantIndexRoute
  '/t/$tenant/jobs/new': typeof TTenantJobsNewRoute
  '/t/$tenant/settings/people': typeof TTenantSettingsPeopleRoute
  '/t/$tenant/settings': typeof TTenantSettingsIndexRoute
  '/t/$tenant/jobs/$job/review': typeof TTenantJobsJobReviewRoute
  '/t/$tenant/settings/billing/alerts': typeof TTenantSettingsBillingAlertsRoute
  '/t/$tenant/settings/billing/partner': typeof TTenantSettingsBillingPartnerRoute
  '/t/$tenant/settings/billing/plan': typeof TTenantSettingsBillingPlanRoute
  '/t/$tenant/settings/billing/usage': typeof TTenantSettingsBillingUsageRoute
  '/t/$tenant/settings/company/activity': typeof TTenantSettingsCompanyActivityRoute
  '/t/$tenant/settings/company/devices': typeof TTenantSettingsCompanyDevicesRoute
  '/t/$tenant/settings/company/documents': typeof TTenantSettingsCompanyDocumentsRoute
  '/t/$tenant/settings/company/general': typeof TTenantSettingsCompanyGeneralRoute
  '/t/$tenant/settings/company/people': typeof TTenantSettingsCompanyPeopleRoute
  '/t/$tenant/settings/company/scan': typeof TTenantSettingsCompanyScanRoute
  '/t/$tenant/settings/company/security': typeof TTenantSettingsCompanySecurityRoute
  '/t/$tenant/settings/developers/keys': typeof TTenantSettingsDevelopersKeysRoute
  '/t/$tenant/settings/developers/scan': typeof TTenantSettingsDevelopersScanRoute
  '/t/$tenant/settings/developers/send': typeof TTenantSettingsDevelopersSendRoute
  '/t/$tenant/settings/billing': typeof TTenantSettingsBillingIndexRoute
  '/t/$tenant/settings/company': typeof TTenantSettingsCompanyIndexRoute
  '/t/$tenant/settings/developers': typeof TTenantSettingsDevelopersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/developers': typeof DevelopersRouteWithChildren
  '/device': typeof DeviceRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invitations': typeof InvitationsRoute
  '/pricing': typeof PricingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/campaigns': typeof AdminCampaignsRoute
  '/admin/desktop-gpus': typeof AdminDesktopGpusRoute
  '/admin/friction': typeof AdminFrictionRoute
  '/admin/funnel': typeof AdminFunnelRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/pools': typeof AdminPoolsRoute
  '/admin/problems': typeof AdminProblemsRoute
  '/admin/queues': typeof AdminQueuesRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/revenue': typeof AdminRevenueRoute
  '/admin/timeline': typeof AdminTimelineRoute
  '/admin/today': typeof AdminTodayRoute
  '/admin/usage': typeof AdminUsageRoute
  '/developers/$guide': typeof DevelopersGuideRoute
  '/developers/reference': typeof DevelopersReferenceRoute
  '/device_/connect': typeof DeviceConnectRoute
  '/device_/connected': typeof DeviceConnectedRoute
  '/email/unsubscribe': typeof EmailUnsubscribeRoute
  '/m/admin': typeof MAdminRoute
  '/m/invite': typeof MInviteRoute
  '/sign-in_/concept': typeof SignInConceptRoute
  '/sign-in_/plain': typeof SignInPlainRoute
  '/t/$tenant': typeof TTenantRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/developers/': typeof DevelopersIndexRoute
  '/admin/customers/$tenant': typeof AdminCustomersTenantRoute
  '/admin/partners/$account': typeof AdminPartnersAccountRoute
  '/t/$tenant/package': typeof TTenantPackageRoute
  '/t/$tenant/settings': typeof TTenantSettingsRouteWithChildren
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/t/$tenant/': typeof TTenantIndexRoute
  '/t/$tenant/jobs/new': typeof TTenantJobsNewRoute
  '/t/$tenant/settings/people': typeof TTenantSettingsPeopleRoute
  '/t/$tenant/settings/': typeof TTenantSettingsIndexRoute
  '/t/$tenant/jobs/$job/review': typeof TTenantJobsJobReviewRoute
  '/t/$tenant/settings/billing/alerts': typeof TTenantSettingsBillingAlertsRoute
  '/t/$tenant/settings/billing/partner': typeof TTenantSettingsBillingPartnerRoute
  '/t/$tenant/settings/billing/plan': typeof TTenantSettingsBillingPlanRoute
  '/t/$tenant/settings/billing/usage': typeof TTenantSettingsBillingUsageRoute
  '/t/$tenant/settings/company/activity': typeof TTenantSettingsCompanyActivityRoute
  '/t/$tenant/settings/company/devices': typeof TTenantSettingsCompanyDevicesRoute
  '/t/$tenant/settings/company/documents': typeof TTenantSettingsCompanyDocumentsRoute
  '/t/$tenant/settings/company/general': typeof TTenantSettingsCompanyGeneralRoute
  '/t/$tenant/settings/company/people': typeof TTenantSettingsCompanyPeopleRoute
  '/t/$tenant/settings/company/scan': typeof TTenantSettingsCompanyScanRoute
  '/t/$tenant/settings/company/security': typeof TTenantSettingsCompanySecurityRoute
  '/t/$tenant/settings/developers/keys': typeof TTenantSettingsDevelopersKeysRoute
  '/t/$tenant/settings/developers/scan': typeof TTenantSettingsDevelopersScanRoute
  '/t/$tenant/settings/developers/send': typeof TTenantSettingsDevelopersSendRoute
  '/t/$tenant/settings/billing/': typeof TTenantSettingsBillingIndexRoute
  '/t/$tenant/settings/company/': typeof TTenantSettingsCompanyIndexRoute
  '/t/$tenant/settings/developers/': typeof TTenantSettingsDevelopersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/developers'
    | '/device'
    | '/forgot-password'
    | '/invitations'
    | '/pricing'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/campaigns'
    | '/admin/desktop-gpus'
    | '/admin/friction'
    | '/admin/funnel'
    | '/admin/health'
    | '/admin/pools'
    | '/admin/problems'
    | '/admin/queues'
    | '/admin/retention'
    | '/admin/revenue'
    | '/admin/timeline'
    | '/admin/today'
    | '/admin/usage'
    | '/developers/$guide'
    | '/developers/reference'
    | '/device/connect'
    | '/device/connected'
    | '/email/unsubscribe'
    | '/m/admin'
    | '/m/invite'
    | '/sign-in/concept'
    | '/sign-in/plain'
    | '/t/$tenant'
    | '/admin/'
    | '/developers/'
    | '/admin/customers/$tenant'
    | '/admin/partners/$account'
    | '/t/$tenant/package'
    | '/t/$tenant/settings'
    | '/admin/partners/'
    | '/t/$tenant/'
    | '/t/$tenant/jobs/new'
    | '/t/$tenant/settings/people'
    | '/t/$tenant/settings/'
    | '/t/$tenant/jobs/$job/review'
    | '/t/$tenant/settings/billing/alerts'
    | '/t/$tenant/settings/billing/partner'
    | '/t/$tenant/settings/billing/plan'
    | '/t/$tenant/settings/billing/usage'
    | '/t/$tenant/settings/company/activity'
    | '/t/$tenant/settings/company/devices'
    | '/t/$tenant/settings/company/documents'
    | '/t/$tenant/settings/company/general'
    | '/t/$tenant/settings/company/people'
    | '/t/$tenant/settings/company/scan'
    | '/t/$tenant/settings/company/security'
    | '/t/$tenant/settings/developers/keys'
    | '/t/$tenant/settings/developers/scan'
    | '/t/$tenant/settings/developers/send'
    | '/t/$tenant/settings/billing/'
    | '/t/$tenant/settings/company/'
    | '/t/$tenant/settings/developers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/device'
    | '/forgot-password'
    | '/invitations'
    | '/pricing'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/campaigns'
    | '/admin/desktop-gpus'
    | '/admin/friction'
    | '/admin/funnel'
    | '/admin/health'
    | '/admin/pools'
    | '/admin/problems'
    | '/admin/queues'
    | '/admin/retention'
    | '/admin/revenue'
    | '/admin/timeline'
    | '/admin/today'
    | '/admin/usage'
    | '/developers/$guide'
    | '/developers/reference'
    | '/device/connect'
    | '/device/connected'
    | '/email/unsubscribe'
    | '/m/admin'
    | '/m/invite'
    | '/sign-in/concept'
    | '/sign-in/plain'
    | '/admin'
    | '/developers'
    | '/admin/customers/$tenant'
    | '/admin/partners/$account'
    | '/t/$tenant/package'
    | '/admin/partners'
    | '/t/$tenant'
    | '/t/$tenant/jobs/new'
    | '/t/$tenant/settings/people'
    | '/t/$tenant/settings'
    | '/t/$tenant/jobs/$job/review'
    | '/t/$tenant/settings/billing/alerts'
    | '/t/$tenant/settings/billing/partner'
    | '/t/$tenant/settings/billing/plan'
    | '/t/$tenant/settings/billing/usage'
    | '/t/$tenant/settings/company/activity'
    | '/t/$tenant/settings/company/devices'
    | '/t/$tenant/settings/company/documents'
    | '/t/$tenant/settings/company/general'
    | '/t/$tenant/settings/company/people'
    | '/t/$tenant/settings/company/scan'
    | '/t/$tenant/settings/company/security'
    | '/t/$tenant/settings/developers/keys'
    | '/t/$tenant/settings/developers/scan'
    | '/t/$tenant/settings/developers/send'
    | '/t/$tenant/settings/billing'
    | '/t/$tenant/settings/company'
    | '/t/$tenant/settings/developers'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/developers'
    | '/device'
    | '/forgot-password'
    | '/invitations'
    | '/pricing'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/campaigns'
    | '/admin/desktop-gpus'
    | '/admin/friction'
    | '/admin/funnel'
    | '/admin/health'
    | '/admin/pools'
    | '/admin/problems'
    | '/admin/queues'
    | '/admin/retention'
    | '/admin/revenue'
    | '/admin/timeline'
    | '/admin/today'
    | '/admin/usage'
    | '/developers/$guide'
    | '/developers/reference'
    | '/device_/connect'
    | '/device_/connected'
    | '/email/unsubscribe'
    | '/m/admin'
    | '/m/invite'
    | '/sign-in_/concept'
    | '/sign-in_/plain'
    | '/t/$tenant'
    | '/admin/'
    | '/developers/'
    | '/admin/customers/$tenant'
    | '/admin/partners/$account'
    | '/t/$tenant/package'
    | '/t/$tenant/settings'
    | '/admin/partners/'
    | '/t/$tenant/'
    | '/t/$tenant/jobs/new'
    | '/t/$tenant/settings/people'
    | '/t/$tenant/settings/'
    | '/t/$tenant/jobs/$job/review'
    | '/t/$tenant/settings/billing/alerts'
    | '/t/$tenant/settings/billing/partner'
    | '/t/$tenant/settings/billing/plan'
    | '/t/$tenant/settings/billing/usage'
    | '/t/$tenant/settings/company/activity'
    | '/t/$tenant/settings/company/devices'
    | '/t/$tenant/settings/company/documents'
    | '/t/$tenant/settings/company/general'
    | '/t/$tenant/settings/company/people'
    | '/t/$tenant/settings/company/scan'
    | '/t/$tenant/settings/company/security'
    | '/t/$tenant/settings/developers/keys'
    | '/t/$tenant/settings/developers/scan'
    | '/t/$tenant/settings/developers/send'
    | '/t/$tenant/settings/billing/'
    | '/t/$tenant/settings/company/'
    | '/t/$tenant/settings/developers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  DevelopersRoute: typeof DevelopersRouteWithChildren
  DeviceRoute: typeof DeviceRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InvitationsRoute: typeof InvitationsRoute
  PricingRoute: typeof PricingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  DeviceConnectRoute: typeof DeviceConnectRoute
  DeviceConnectedRoute: typeof DeviceConnectedRoute
  EmailUnsubscribeRoute: typeof EmailUnsubscribeRoute
  MAdminRoute: typeof MAdminRoute
  MInviteRoute: typeof MInviteRoute
  SignInConceptRoute: typeof SignInConceptRoute
  SignInPlainRoute: typeof SignInPlainRoute
  TTenantRoute: typeof TTenantRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers': {
      id: '/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof DevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations': {
      id: '/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof InvitationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/campaigns': {
      id: '/admin/campaigns'
      path: '/campaigns'
      fullPath: '/admin/campaigns'
      preLoaderRoute: typeof AdminCampaignsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/desktop-gpus': {
      id: '/admin/desktop-gpus'
      path: '/desktop-gpus'
      fullPath: '/admin/desktop-gpus'
      preLoaderRoute: typeof AdminDesktopGpusRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/friction': {
      id: '/admin/friction'
      path: '/friction'
      fullPath: '/admin/friction'
      preLoaderRoute: typeof AdminFrictionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/funnel': {
      id: '/admin/funnel'
      path: '/funnel'
      fullPath: '/admin/funnel'
      preLoaderRoute: typeof AdminFunnelRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pools': {
      id: '/admin/pools'
      path: '/pools'
      fullPath: '/admin/pools'
      preLoaderRoute: typeof AdminPoolsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/problems': {
      id: '/admin/problems'
      path: '/problems'
      fullPath: '/admin/problems'
      preLoaderRoute: typeof AdminProblemsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/queues': {
      id: '/admin/queues'
      path: '/queues'
      fullPath: '/admin/queues'
      preLoaderRoute: typeof AdminQueuesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/retention': {
      id: '/admin/retention'
      path: '/retention'
      fullPath: '/admin/retention'
      preLoaderRoute: typeof AdminRetentionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/revenue': {
      id: '/admin/revenue'
      path: '/revenue'
      fullPath: '/admin/revenue'
      preLoaderRoute: typeof AdminRevenueRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/timeline': {
      id: '/admin/timeline'
      path: '/timeline'
      fullPath: '/admin/timeline'
      preLoaderRoute: typeof AdminTimelineRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/today': {
      id: '/admin/today'
      path: '/today'
      fullPath: '/admin/today'
      preLoaderRoute: typeof AdminTodayRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/usage': {
      id: '/admin/usage'
      path: '/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AdminUsageRouteImport
      parentRoute: typeof AdminRoute
    }
    '/developers/': {
      id: '/developers/'
      path: '/'
      fullPath: '/developers/'
      preLoaderRoute: typeof DevelopersIndexRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/developers/$guide': {
      id: '/developers/$guide'
      path: '/$guide'
      fullPath: '/developers/$guide'
      preLoaderRoute: typeof DevelopersGuideRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/developers/reference': {
      id: '/developers/reference'
      path: '/reference'
      fullPath: '/developers/reference'
      preLoaderRoute: typeof DevelopersReferenceRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/device_/connect': {
      id: '/device_/connect'
      path: '/device/connect'
      fullPath: '/device/connect'
      preLoaderRoute: typeof DeviceConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device_/connected': {
      id: '/device_/connected'
      path: '/device/connected'
      fullPath: '/device/connected'
      preLoaderRoute: typeof DeviceConnectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email/unsubscribe': {
      id: '/email/unsubscribe'
      path: '/email/unsubscribe'
      fullPath: '/email/unsubscribe'
      preLoaderRoute: typeof EmailUnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/admin': {
      id: '/m/admin'
      path: '/m/admin'
      fullPath: '/m/admin'
      preLoaderRoute: typeof MAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/invite': {
      id: '/m/invite'
      path: '/m/invite'
      fullPath: '/m/invite'
      preLoaderRoute: typeof MInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in_/concept': {
      id: '/sign-in_/concept'
      path: '/sign-in/concept'
      fullPath: '/sign-in/concept'
      preLoaderRoute: typeof SignInConceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in_/plain': {
      id: '/sign-in_/plain'
      path: '/sign-in/plain'
      fullPath: '/sign-in/plain'
      preLoaderRoute: typeof SignInPlainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$tenant': {
      id: '/t/$tenant'
      path: '/t/$tenant'
      fullPath: '/t/$tenant'
      preLoaderRoute: typeof TTenantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/customers/$tenant': {
      id: '/admin/customers/$tenant'
      path: '/customers/$tenant'
      fullPath: '/admin/customers/$tenant'
      preLoaderRoute: typeof AdminCustomersTenantRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/partners/': {
      id: '/admin/partners/'
      path: '/partners'
      fullPath: '/admin/partners/'
      preLoaderRoute: typeof AdminPartnersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/partners/$account': {
      id: '/admin/partners/$account'
      path: '/partners/$account'
      fullPath: '/admin/partners/$account'
      preLoaderRoute: typeof AdminPartnersAccountRouteImport
      parentRoute: typeof AdminRoute
    }
    '/t/$tenant/': {
      id: '/t/$tenant/'
      path: '/'
      fullPath: '/t/$tenant/'
      preLoaderRoute: typeof TTenantIndexRouteImport
      parentRoute: typeof TTenantRoute
    }
    '/t/$tenant/package': {
      id: '/t/$tenant/package'
      path: '/package'
      fullPath: '/t/$tenant/package'
      preLoaderRoute: typeof TTenantPackageRouteImport
      parentRoute: typeof TTenantRoute
    }
    '/t/$tenant/settings': {
      id: '/t/$tenant/settings'
      path: '/settings'
      fullPath: '/t/$tenant/settings'
      preLoaderRoute: typeof TTenantSettingsRouteImport
      parentRoute: typeof TTenantRoute
    }
    '/t/$tenant/jobs/new': {
      id: '/t/$tenant/jobs/new'
      path: '/jobs/new'
      fullPath: '/t/$tenant/jobs/new'
      preLoaderRoute: typeof TTenantJobsNewRouteImport
      parentRoute: typeof TTenantRoute
    }
    '/t/$tenant/settings/': {
      id: '/t/$tenant/settings/'
      path: '/'
      fullPath: '/t/$tenant/settings/'
      preLoaderRoute: typeof TTenantSettingsIndexRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/people': {
      id: '/t/$tenant/settings/people'
      path: '/people'
      fullPath: '/t/$tenant/settings/people'
      preLoaderRoute: typeof TTenantSettingsPeopleRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/jobs/$job/review': {
      id: '/t/$tenant/jobs/$job/review'
      path: '/jobs/$job/review'
      fullPath: '/t/$tenant/jobs/$job/review'
      preLoaderRoute: typeof TTenantJobsJobReviewRouteImport
      parentRoute: typeof TTenantRoute
    }
    '/t/$tenant/settings/billing/': {
      id: '/t/$tenant/settings/billing/'
      path: '/billing'
      fullPath: '/t/$tenant/settings/billing/'
      preLoaderRoute: typeof TTenantSettingsBillingIndexRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/billing/alerts': {
      id: '/t/$tenant/settings/billing/alerts'
      path: '/billing/alerts'
      fullPath: '/t/$tenant/settings/billing/alerts'
      preLoaderRoute: typeof TTenantSettingsBillingAlertsRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/billing/partner': {
      id: '/t/$tenant/settings/billing/partner'
      path: '/billing/partner'
      fullPath: '/t/$tenant/settings/billing/partner'
      preLoaderRoute: typeof TTenantSettingsBillingPartnerRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/billing/plan': {
      id: '/t/$tenant/settings/billing/plan'
      path: '/billing/plan'
      fullPath: '/t/$tenant/settings/billing/plan'
      preLoaderRoute: typeof TTenantSettingsBillingPlanRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/billing/usage': {
      id: '/t/$tenant/settings/billing/usage'
      path: '/billing/usage'
      fullPath: '/t/$tenant/settings/billing/usage'
      preLoaderRoute: typeof TTenantSettingsBillingUsageRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/': {
      id: '/t/$tenant/settings/company/'
      path: '/company'
      fullPath: '/t/$tenant/settings/company/'
      preLoaderRoute: typeof TTenantSettingsCompanyIndexRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/activity': {
      id: '/t/$tenant/settings/company/activity'
      path: '/company/activity'
      fullPath: '/t/$tenant/settings/company/activity'
      preLoaderRoute: typeof TTenantSettingsCompanyActivityRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/devices': {
      id: '/t/$tenant/settings/company/devices'
      path: '/company/devices'
      fullPath: '/t/$tenant/settings/company/devices'
      preLoaderRoute: typeof TTenantSettingsCompanyDevicesRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/documents': {
      id: '/t/$tenant/settings/company/documents'
      path: '/company/documents'
      fullPath: '/t/$tenant/settings/company/documents'
      preLoaderRoute: typeof TTenantSettingsCompanyDocumentsRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/general': {
      id: '/t/$tenant/settings/company/general'
      path: '/company/general'
      fullPath: '/t/$tenant/settings/company/general'
      preLoaderRoute: typeof TTenantSettingsCompanyGeneralRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/people': {
      id: '/t/$tenant/settings/company/people'
      path: '/company/people'
      fullPath: '/t/$tenant/settings/company/people'
      preLoaderRoute: typeof TTenantSettingsCompanyPeopleRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/scan': {
      id: '/t/$tenant/settings/company/scan'
      path: '/company/scan'
      fullPath: '/t/$tenant/settings/company/scan'
      preLoaderRoute: typeof TTenantSettingsCompanyScanRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/company/security': {
      id: '/t/$tenant/settings/company/security'
      path: '/company/security'
      fullPath: '/t/$tenant/settings/company/security'
      preLoaderRoute: typeof TTenantSettingsCompanySecurityRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/developers/': {
      id: '/t/$tenant/settings/developers/'
      path: '/developers'
      fullPath: '/t/$tenant/settings/developers/'
      preLoaderRoute: typeof TTenantSettingsDevelopersIndexRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/developers/keys': {
      id: '/t/$tenant/settings/developers/keys'
      path: '/developers/keys'
      fullPath: '/t/$tenant/settings/developers/keys'
      preLoaderRoute: typeof TTenantSettingsDevelopersKeysRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/developers/scan': {
      id: '/t/$tenant/settings/developers/scan'
      path: '/developers/scan'
      fullPath: '/t/$tenant/settings/developers/scan'
      preLoaderRoute: typeof TTenantSettingsDevelopersScanRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
    '/t/$tenant/settings/developers/send': {
      id: '/t/$tenant/settings/developers/send'
      path: '/developers/send'
      fullPath: '/t/$tenant/settings/developers/send'
      preLoaderRoute: typeof TTenantSettingsDevelopersSendRouteImport
      parentRoute: typeof TTenantSettingsRoute
    }
  }
}

interface AdminRouteChildren {
  AdminCampaignsRoute: typeof AdminCampaignsRoute
  AdminDesktopGpusRoute: typeof AdminDesktopGpusRoute
  AdminFrictionRoute: typeof AdminFrictionRoute
  AdminFunnelRoute: typeof AdminFunnelRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminPoolsRoute: typeof AdminPoolsRoute
  AdminProblemsRoute: typeof AdminProblemsRoute
  AdminQueuesRoute: typeof AdminQueuesRoute
  AdminRetentionRoute: typeof AdminRetentionRoute
  AdminRevenueRoute: typeof AdminRevenueRoute
  AdminTimelineRoute: typeof AdminTimelineRoute
  AdminTodayRoute: typeof AdminTodayRoute
  AdminUsageRoute: typeof AdminUsageRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCustomersTenantRoute: typeof AdminCustomersTenantRoute
  AdminPartnersAccountRoute: typeof AdminPartnersAccountRoute
  AdminPartnersIndexRoute: typeof AdminPartnersIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCampaignsRoute: AdminCampaignsRoute,
  AdminDesktopGpusRoute: AdminDesktopGpusRoute,
  AdminFrictionRoute: AdminFrictionRoute,
  AdminFunnelRoute: AdminFunnelRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminPoolsRoute: AdminPoolsRoute,
  AdminProblemsRoute: AdminProblemsRoute,
  AdminQueuesRoute: AdminQueuesRoute,
  AdminRetentionRoute: AdminRetentionRoute,
  AdminRevenueRoute: AdminRevenueRoute,
  AdminTimelineRoute: AdminTimelineRoute,
  AdminTodayRoute: AdminTodayRoute,
  AdminUsageRoute: AdminUsageRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCustomersTenantRoute: AdminCustomersTenantRoute,
  AdminPartnersAccountRoute: AdminPartnersAccountRoute,
  AdminPartnersIndexRoute: AdminPartnersIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DevelopersRouteChildren {
  DevelopersGuideRoute: typeof DevelopersGuideRoute
  DevelopersReferenceRoute: typeof DevelopersReferenceRoute
  DevelopersIndexRoute: typeof DevelopersIndexRoute
}

const DevelopersRouteChildren: DevelopersRouteChildren = {
  DevelopersGuideRoute: DevelopersGuideRoute,
  DevelopersReferenceRoute: DevelopersReferenceRoute,
  DevelopersIndexRoute: DevelopersIndexRoute,
}

const DevelopersRouteWithChildren = DevelopersRoute._addFileChildren(
  DevelopersRouteChildren,
)

interface TTenantSettingsRouteChildren {
  TTenantSettingsPeopleRoute: typeof TTenantSettingsPeopleRoute
  TTenantSettingsIndexRoute: typeof TTenantSettingsIndexRoute
  TTenantSettingsBillingAlertsRoute: typeof TTenantSettingsBillingAlertsRoute
  TTenantSettingsBillingPartnerRoute: typeof TTenantSettingsBillingPartnerRoute
  TTenantSettingsBillingPlanRoute: typeof TTenantSettingsBillingPlanRoute
  TTenantSettingsBillingUsageRoute: typeof TTenantSettingsBillingUsageRoute
  TTenantSettingsCompanyActivityRoute: typeof TTenantSettingsCompanyActivityRoute
  TTenantSettingsCompanyDevicesRoute: typeof TTenantSettingsCompanyDevicesRoute
  TTenantSettingsCompanyDocumentsRoute: typeof TTenantSettingsCompanyDocumentsRoute
  TTenantSettingsCompanyGeneralRoute: typeof TTenantSettingsCompanyGeneralRoute
  TTenantSettingsCompanyPeopleRoute: typeof TTenantSettingsCompanyPeopleRoute
  TTenantSettingsCompanyScanRoute: typeof TTenantSettingsCompanyScanRoute
  TTenantSettingsCompanySecurityRoute: typeof TTenantSettingsCompanySecurityRoute
  TTenantSettingsDevelopersKeysRoute: typeof TTenantSettingsDevelopersKeysRoute
  TTenantSettingsDevelopersScanRoute: typeof TTenantSettingsDevelopersScanRoute
  TTenantSettingsDevelopersSendRoute: typeof TTenantSettingsDevelopersSendRoute
  TTenantSettingsBillingIndexRoute: typeof TTenantSettingsBillingIndexRoute
  TTenantSettingsCompanyIndexRoute: typeof TTenantSettingsCompanyIndexRoute
  TTenantSettingsDevelopersIndexRoute: typeof TTenantSettingsDevelopersIndexRoute
}

const TTenantSettingsRouteChildren: TTenantSettingsRouteChildren = {
  TTenantSettingsPeopleRoute: TTenantSettingsPeopleRoute,
  TTenantSettingsIndexRoute: TTenantSettingsIndexRoute,
  TTenantSettingsBillingAlertsRoute: TTenantSettingsBillingAlertsRoute,
  TTenantSettingsBillingPartnerRoute: TTenantSettingsBillingPartnerRoute,
  TTenantSettingsBillingPlanRoute: TTenantSettingsBillingPlanRoute,
  TTenantSettingsBillingUsageRoute: TTenantSettingsBillingUsageRoute,
  TTenantSettingsCompanyActivityRoute: TTenantSettingsCompanyActivityRoute,
  TTenantSettingsCompanyDevicesRoute: TTenantSettingsCompanyDevicesRoute,
  TTenantSettingsCompanyDocumentsRoute: TTenantSettingsCompanyDocumentsRoute,
  TTenantSettingsCompanyGeneralRoute: TTenantSettingsCompanyGeneralRoute,
  TTenantSettingsCompanyPeopleRoute: TTenantSettingsCompanyPeopleRoute,
  TTenantSettingsCompanyScanRoute: TTenantSettingsCompanyScanRoute,
  TTenantSettingsCompanySecurityRoute: TTenantSettingsCompanySecurityRoute,
  TTenantSettingsDevelopersKeysRoute: TTenantSettingsDevelopersKeysRoute,
  TTenantSettingsDevelopersScanRoute: TTenantSettingsDevelopersScanRoute,
  TTenantSettingsDevelopersSendRoute: TTenantSettingsDevelopersSendRoute,
  TTenantSettingsBillingIndexRoute: TTenantSettingsBillingIndexRoute,
  TTenantSettingsCompanyIndexRoute: TTenantSettingsCompanyIndexRoute,
  TTenantSettingsDevelopersIndexRoute: TTenantSettingsDevelopersIndexRoute,
}

const TTenantSettingsRouteWithChildren = TTenantSettingsRoute._addFileChildren(
  TTenantSettingsRouteChildren,
)

interface TTenantRouteChildren {
  TTenantPackageRoute: typeof TTenantPackageRoute
  TTenantSettingsRoute: typeof TTenantSettingsRouteWithChildren
  TTenantIndexRoute: typeof TTenantIndexRoute
  TTenantJobsNewRoute: typeof TTenantJobsNewRoute
  TTenantJobsJobReviewRoute: typeof TTenantJobsJobReviewRoute
}

const TTenantRouteChildren: TTenantRouteChildren = {
  TTenantPackageRoute: TTenantPackageRoute,
  TTenantSettingsRoute: TTenantSettingsRouteWithChildren,
  TTenantIndexRoute: TTenantIndexRoute,
  TTenantJobsNewRoute: TTenantJobsNewRoute,
  TTenantJobsJobReviewRoute: TTenantJobsJobReviewRoute,
}

const TTenantRouteWithChildren =
  TTenantRoute._addFileChildren(TTenantRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  DevelopersRoute: DevelopersRouteWithChildren,
  DeviceRoute: DeviceRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InvitationsRoute: InvitationsRoute,
  PricingRoute: PricingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  DeviceConnectRoute: DeviceConnectRoute,
  DeviceConnectedRoute: DeviceConnectedRoute,
  EmailUnsubscribeRoute: EmailUnsubscribeRoute,
  MAdminRoute: MAdminRoute,
  MInviteRoute: MInviteRoute,
  SignInConceptRoute: SignInConceptRoute,
  SignInPlainRoute: SignInPlainRoute,
  TTenantRoute: TTenantRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
